'use client';

export interface StepStatusRegionProps {
  /** What to announce now; empty when there is nothing to say. */
  message: string;
  tone?: 'neutral' | 'error';
}

/**
 * The step's one polite live region (ADR-025). It stays mounted from the
 * first render and only its text changes, so screen readers announce loading,
 * errors and recoveries as they happen.
 */
export function StepStatusRegion({ message, tone = 'neutral' }: StepStatusRegionProps) {
  return (
    <p
      className="signup-step__status"
      aria-live="polite"
      data-tone={tone}
      data-testid="signup-step-status"
    >
      {message}
    </p>
  );
}
